import React from 'react';
import { Controller } from 'react-hook-form';
import { withTranslation } from 'react-i18next';
import ReactSelect from 'react-select';

import styles from './style';

const Select = ({ t, control, register = {}, type = 'text', options = [], ...rest }) => {
    // Options can be grouped, flat them to make selection easier
    const flatOptions = options.reduce((acc, e) => [...acc, ...(Array.isArray(e.options) ? e.options : [e])], []);

    if (!control) {
        return (
            <ReactSelect
                menuPortalTarget={document.querySelector('body')}
                classNamePrefix="react-select"
                styles={styles}
                placeholder={t('Select…')}
                type={type}
                noOptionsMessage={() => t('No options')}
                options={options}
                {...rest}
                value={typeof rest?.value !== 'undefined' ? flatOptions.find((option) => option.value === rest.value) || null : null}
            />
        );
    }

    const renderController = ({ field: { value, onChange, onBlur } }) => (
        <ReactSelect
            menuPortalTarget={document.querySelector('body')}
            classNamePrefix="react-select"
            styles={styles}
            placeholder={t('Select…')}
            type={type}
            value={
                Array.isArray(value)
                    ? flatOptions.filter((option) => value.includes(option.value))
                    : flatOptions.find((option) => option.value === value)
            }
            onChange={(val) => onChange(Array.isArray(val) ? val.map((v) => v.value) : val.value)}
            noOptionsMessage={() => t('No options')}
            onBlur={onBlur}
            options={options}
            {...rest}
        />
    );

    return <Controller name={register.name} control={control} render={renderController} />;
};

export default React.memo(withTranslation()(Select));
